import { render, staticRenderFns } from "./PrincipalCardLogByUid.vue?vue&type=template&id=2288e9da&scoped=true"
import script from "./PrincipalCardLogByUid.vue?vue&type=script&lang=js"
export * from "./PrincipalCardLogByUid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288e9da",
  null
  
)

export default component.exports